import { useMutation } from '@apollo/client'
import { AddVaccination, AddVaccinationVariables } from '../../types'
import { ADD_VACCINATION } from './operations'

export const useAddVaccination = () =>
  useMutation<AddVaccination, AddVaccinationVariables>(ADD_VACCINATION)
